const clientSideValidation = require('app_byl_core/components/clientSideValidation');
const documentTypeSelector = require('app_byl_core/components/ds/forms/document-type-selector');
const countryPrefixSelector = require('app_byl_core/components/ds/forms/country-prefix-selector');
const formValidation = require('app_byl_core/components/formValidation');
const loader = require('app_byl_core/components/loader');
const {
    clearFormErrors,
    scrollToError,
} = require('app_byl_core/components/forms');
const { onOnce } = require('app_byl_core/common/utils/domEvents');

const parentClass = 'form-claims';
const submitButtonClass = `.${parentClass}__submit`;
const eventError = `${parentClass}:error`;
const eventSubmit = `${parentClass}:submit`;
const eventSuccess = `${parentClass}:success`;
const getForm = () => document.querySelector(`.${parentClass}__form`);

function sendEvents(eventName, data = null) {
    const event = new CustomEvent(eventName, {
        detail: data,
    });
    return document.dispatchEvent(event);
}

function getCustomFieldsByFormData(formData) {
    const { name: phoneNumberName } = document.getElementById('claims-phone');
    const { name: phonePrefixName } =
        document.getElementById('claims-phonePrefix');
    const newPhoneNumberValue = `${formData.get(phonePrefixName)} ${formData.get(phoneNumberName)}`;
    formData.set(phoneNumberName, newPhoneNumberValue);
    formData.delete(phonePrefixName);
    return formData;
}

/**
 * It takes the form data, sends it to the server and redirects to a success or
 * error page
 * @param {HTMLFormElement} form - the form element
 * @param {FormData} formData - the data from the form
 */
function submitForm(form, formData) {
    const submitButton = form.querySelector(submitButtonClass);
    loader.addLoader(submitButton);
    sendEvents(eventSubmit);

    fetch(form.getAttribute('action'), {
        method: 'POST',
        body: formData,
    })
        .then((response) => response.json())
        .then((data) => {
            if (data.success) {
                // Reset form
                form.reset();
                $('body').trigger('interaction--swap-text-event', submitButton);
                submitButton.disabled = true;
                sendEvents(eventSuccess, data);
            } else {
                formValidation(form, data);
                scrollToError(form);
                sendEvents(eventError, data);
            }
        })
        .catch((err) => {
            sendEvents(eventError, err);
        })
        .finally(() => {
            grecaptcha.reset();
            loader.removeLoader(submitButton);
        });
}

function validateRecaptcha() {
    const hiddenRecaptcha = document.querySelector('.hiddenRecaptcha');
    if (hiddenRecaptcha.value !== '') {
        return true;
    }

    grecaptcha.execute();
    return false;
}

/**
 * It validates the form data, and if it's valid, it submits the form
 * @param {Event} e - the event object
 */
function validateForm(e) {
    e.preventDefault();
    const form = getForm();
    const formData = new FormData(form);
    const validationCallbacks = validateRecaptcha;

    clearFormErrors(form);

    let valid = clientSideValidation.functions.validateFormatData(form);

    if (valid) valid = validationCallbacks.call(null, formData);

    if (valid) {
        submitForm(form, getCustomFieldsByFormData(formData));
    } else {
        scrollToError(form);
    }
}

/**
 * When the page loads, initialize the form validation and the repeater.
 */
onOnce(window, 'load', () => {
    const form = getForm();
    form?.addEventListener('submit', validateForm);
    documentTypeSelector.init();
    countryPrefixSelector.init();
});

onOnce(window, 'beforeunload', () => {
    const form = getForm();
    form?.removeEventListener('submit', validateForm);
});
